<template>
  <div class="home">
    <!-- Slider -->
    <Slider  id="inicio"  style="z-index:0!important;position:relative;display:block"/>

    <SeparatorSection
    :titleOne="'URGENCIAS'" 
    :titleOneColor="'has-text-white fontWeightBlack'"
    :titleTwo="'24 HS'"
    :titleTwoColor="'colorPrimary fontWeightBlack'"
    :titleThree="''"
    :titleThreeColor="'has-text-white fontWeightBlack'"
    :subtitleOne="'Contactanos ahora y visitamos tu hogar para resolver la emergencia ¡Llamanos Ya!'"
    :subtitleTwo="'Roturas de cañería - Fugas de gas - Destapaciones - Mucho más'"
    :subtitleColor="'has-text-white'"
    :bgSeparator="'bgColorBlack pt-6'"
    />
    <p
      class="mx-auto | has-text-dark letterSpacingShort fontWeight is-size-4 has-text-centered mb-2 mt-6"
    >
        <span class="is-size-2 fontWeightBlack fontMoreBlack fontUpperCase fontItalic">
          Contamos con tecnologías <br> de 
        </span>
         <span class="is-size-2 fontWeightBlack fontMoreBlack fontUpperCase fontItalic colorSecondary">
          última generación
        </span>
    </p>
        <p
      class="mx-auto | has-text-dark letterSpacingShort fontWeight is-size-4 has-text-centered mb-2 mt-2"
    >
        <span class="is-size-5 fontWeightRegular fontUpperCase">
          Equipo para detección de fuga de gas y agua
        </span>
        <br>
         <span class="is-size-5 fontWeightRegular  fontUpperCase">
          Equipo de rotosonda para destapaciones de cañería.
        </span>
    </p>

    <img src="@/assets/img/mercadopago.jpg" class="width100 is-hidden-mobile pt-6"> 
    <img src="@/assets/img/mercadopago4.jpg" class="width100 is-hidden-tablet"> 
    <SeparatorSection
      :titleOne="'15 años'" 
      :titleOneColor="'has-text-white fontWeightBlack fontUpperCase'"
      :titleTwo="'DE EXPERIENCIA'"
      :titleTwoColor="'colorPrimary fontWeightBlack'"
      :titleThreeColor="'has-text-white fontWeightBlack'"
      :subtitleOne="'Trabajamos en La Plata, City Bell, Los Hornos, Berisso, Ensenada y San Carlos, todo Gran La Plata'"
      :subtitleColor="'has-text-white'"
      :subtitleTwo="'.'"
      :bgSeparator="'bgColorBlack p-6'"
    />
    <SeparatorImages />
     <div class="container pl-4 pr-4">
        <div class="pt-6 pb-6">
           <p
              class="mx-auto | has-text-dark letterSpacingShort fontWeight is-size-4 has-text-centered mb-2"
            >
                        <span class="is-size-2 fontWeightBlack fontUpperCase fontItalic">Vemos lo que otros imaginan</span>
           </p>
           <p
              class="mx-auto | has-text-dark letterSpacingShort fontWeight is-size-4 textAlignResponsiveCenter"
            >

          Poseemos detectores de fugas y trabajamos en el lugar exacto.
          Localizamos <b>perdidas de agua y gas en el acto, gracias a detectores y tecnologías de última generación. </b>
          Rompemos en el lugar exacto. Realizamos video inspección en cañerías de desagües. Tenemos detectores por ultra sonido. Tenemos maquinas rotosonda para destapaciones sanitarias. 
            </p>
            <br>
            <p
              class="mx-auto | has-text-centered has-text-dark letterSpacingShort fontWeight is-size-4"
            >
              Las reparaciones más confiables | Vamos en el momento
            </p>
            <p
              class="mx-auto mt-3 | has-text-centered has-text-dark letterSpacingShort fontWeight is-size-4 heartbeat"
            >
            <b><a href="tel:+542216382108" class="has-text-dark">¡Llamá ahora!</a></b>
            </p>
            <div class="separatorLine bgColorSecondary mt-5 mb-5 width100px mx-auto is-block"></div>
            <p
              class="mx-auto mt-3 | has-text-centered has-text-dark letterSpacingShort fontWeight is-size-4"
            >
            Elegí LF Soluciones
            </p>
        </div>
      </div>
       <section id="comments"></section>

    <Comments />
               <div class="columns is-multiline" style="overflow:none!important">
      <div class="column is-4 p-0">
        <img src="@/assets/img/obras/fotos/7.jpg" class="width100 is-block">
      </div>
      <div class="column is-4 p-0">
        <img src="@/assets/img/obras/fotos/2.jpg" class="width100 is-block">
      </div>
      <div class="column is-4 p-0">
        <img src="@/assets/img/obras/fotos/9.jpg" class="width100 is-block">
      </div> 
    </div>
    <br><br><br>
 <section id="services"></section>
    <Services 
    :title="'SERVICIOS'" 
    :propName1="'Plomería de hogar'"
    :propImg1="'toolbox'"
    :propName2="'Gasista general'"
    :propImg2="'tools'"
    :propName3="'Destapaciones'"
    :propImg3="'toilet'"
    :propName4="'Reparación de estufas'"
    :propImg4="'fire'"
    :propName5="'Reparación de calefones'"
    :propImg5="'shower'"
    :propName6="'Reparación de cañerías'"
    :propImg6="'tint'"   
    :classContainer="'mt-0 mb-6 pb-4'"
    />
    <br>
    <SeparatorSection
    :titleOne="'MANTENEMOS UN PRECIO'" 
    :titleOneColor="'has-text-white fontWeightBlack fontUpperCase is-size-1-tablet is-size-3-mobile'"
    :titleTwo="'COMPETITIVO'"
    :titleTwoColor="'colorPrimary fontWeightBlack is-size-1-tablet is-size-3-mobile'"
    :titleThree="''"
    :titleThreeColor="'has-text-white fontWeightBlack'"
    :subtitleOne="'Con el objetivo de brindar el mejor servicio a quienes nos eligen mantenemos una tarifa accesible para todos'"
    :subtitleTwo="''"
    :subtitleColor="'has-text-white'"
    :bgSeparator="'bgColorBlack p-6'"
    />
    <TwoRows />
        <SeparatorSection
    :titleOne="'INSTALACIONES COMPLETAS'" 
    :titleOneColor="'has-text-white fontWeightBlack fontUpperCase is-size-1-tablet is-size-3-mobile'"
    :titleTwo="'PARA EDIFICIOS Y VIVIENDAS'"
    :titleTwoColor="'colorPrimary fontWeightBlack is-size-1-tablet is-size-3-mobile'"
    :titleThree="''"
    :titleThreeColor="'has-text-white fontWeightBlack'"
    :subtitleOne="'Realizamos la instalación completa de cañería y gas en obras, contactanos ahora para recibir un presupuesto'"
    :subtitleTwo="''"
    :subtitleColor="'has-text-white'"
    :bgSeparator="'bgColorBlack p-6'"
    />
    <div class="columns is-multiline" style="overflow:none!important">
      <div class="column is-4 p-0">
        <img src="@/assets/img/obras/fotos/1.jpg" class="width100 is-block">
      </div>
      <div class="column is-4 p-0">
        <img src="@/assets/img/obras/fotos/8.jpg" class="width100 is-block">
      </div>
      <div class="column is-4 p-0">
        <img src="@/assets/img/obras/fotos/3.jpg" class="width100 is-block">
      </div> 
    </div> 
    <section id="us"></section>
    <div class="container-fluid pt-5 pb-2">
      <br><br><br>
      <div class="container pl-6 pr-6">
            <img src="@/assets/img/isologo.png"
            class="mx-auto is-block mt-4" style="width:150px"
            > 
      <h1
        class="titleBig2 has-text-dark fontWeightBlack fontMoreBlack mt-6 mb-5  pt-1 pl-6 pr-6 fontUpperCase">
        15 años de servicio
      </h1>
          <p
            class="is-size-4 mb-6 textAlignResponsiveCenter">
            LF Soluciones | Plomero y Gasista matriculado con más de 15 años de experiencia en La Plata y alrededores. Hemos realizado casas en toda la zona por lo que podemos brindar referencias comprobables ¡Contactanos ahora! El presupuesto y la visita es sin cargo para brindar la mejor atención.
          </p>
      </div> 
    </div>
      
    <div class="container-fluid pb-6">

      <NumberCounter class="is-inline-block"/>
      <NumberCounterTwo class="is-inline-block ml-2"/> 
    <div class="container">
      <div class="columns is-multiline">
        <div class="column is-2">
           <img src="@/assets/img/marcas/1.jpg" class="width100"> 
        </div>
                <div class="column is-2">
           <img src="@/assets/img/marcas/2.jpg" class="width100"> 
        </div>
                <div class="column is-2">
           <img src="@/assets/img/marcas/7.jpg" class="width100"> 
        </div>
                <div class="column is-2">
           <img src="@/assets/img/marcas/4.jpg" class="width100"> 
        </div>
                <div class="column is-2">
           <img src="@/assets/img/marcas/5.jpg" class="width100"> 
        </div>
                <div class="column is-2">
           <img src="@/assets/img/marcas/6.jpg" class="width100"> 
        </div>
      </div>
    </div>

    </div>

   <SeparatorImagesTwo />
   <section id="contacto"></section>
    <div class="container-fluid pl-6 pr-6 bgColorBlack">
        <div class="row">
          <div class="columns is-multiline pt-6 pb-6">
            <div class="column is-12-mobile is-12-tablet is-6-desktop is-6-widescreen is-6-fullhd">
              <p class="titleBig3 fontWeightBlack has-text-white  fontMoreBlack mb-3"> Contactanos Ya </p>
                  <button
                  class="button3dPrimary p-4 bgColorSecondary mx-auto is-block"
                  @click="goWhatsapp">
                      <img src="@/assets/img/whatsapp.webp" class="imgWp">
                      <p class="is-inline-block is-size-4 has-text-dark fontWeightBlack fontUpperCase letterSpacingShort">Presupuestos</p>
                  </button>
            </div> 
            <div class="column is-12-mobile is-12-tablet is-6-desktop is-6-widescreen is-6-fullhd pr-0 paddingFooterEspecial">
              <p class="titleBig3  textAlignResponsive fontWeightBlack  has-text-white">
                Teléfono
              </p>
              <div class="separatorLine bgColorSecondary width20 mt-3 opacity08 mx-auto is-block is-hidden-tablet"></div>
                <div class="separatorLine bgColorSecondary width20 mt-3 opacity08 is-hidden-mobile"></div>
                  <div class="textAlignResponsive">
                      <br>
                        <font-awesome-icon icon="mobile-alt" class="colorPrimary is-inline-block subtitle1" />
                        <a :href="brand.phoneUrl" class="is-inline-block subtitle1 ml-2  has-text-white" >
                           {{brand.phone}} 
                        </a>
                        <br>
                        <font-awesome-icon icon="map-marker-alt" class="colorPrimary is-inline-block subtitle1" />
                        <p class="is-inline-block subtitle1 ml-2 has-text-white" >
                          La Plata y alrededores
                        </p>
                      <br>
                  </div>
            </div>           
          </div>
        </div>
      </div>
      
 



    <!-- Footer -->
    <Footer id="contact" />
    <Whatsapp />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import Slider from '@/components/sections/Slider'
import SeparatorSection from '@/components/sections/SeparatorSection'
import Comments from '@/components/sections/Comments'
import SeparatorImages from '@/components/sections/SeparatorImages'
import SeparatorImagesTwo from '@/components/sections/SeparatorImagesTwo'
import Services from '@/components/sections/Services'
import TwoRows from '@/components/sections/TwoRows'
import NumberCounter from '@/components/sections/NumberCounterJs'
import NumberCounterTwo from '@/components/sections/NumberCounterJsTwo'
import Footer from '@/components/Footer'
import Whatsapp from '@/components/Whatsapp'
export default {
  name: 'Home',
  components: {
    Slider ,
    SeparatorSection,
    Comments,
    SeparatorImages,
    SeparatorImagesTwo,
    Services,
    TwoRows,
    NumberCounter,
    NumberCounterTwo,
    Footer,
    Whatsapp
  },
    computed: {
    ...mapState('brand', ['brand'])
  },
    methods: {
      goWhatsapp () {
        window.location.href=`https://api.whatsapp.com/send?phone=${this.brand.phone}`
      }
  }
}
</script>
